import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import {
  getIsLoggedInSelector,
  getHasAuthLoadedSelector,
} from '@americanexpress/travel-selectors';
import { useDDL } from '@americanexpress/react-ddl';
import browserCookies from 'browser-cookies';
import { getMembersProductsList } from '../../selectors/productsSelectors';

const DigitalDataLayer = () => {
  const { updateDDL } = useDDL();
  const productsList = useSelector(getMembersProductsList);
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const hasAuthLoaded = useSelector(getHasAuthLoadedSelector);

  React.useEffect(() => {
    if (hasAuthLoaded) {
      updateDDL({ name: 'user.authenticated', value: !!isLoggedIn });
    }
  }, [hasAuthLoaded, isLoggedIn]);

  React.useEffect(() => {
    updateDDL({ name: 'user.publicGuid', value: browserCookies.get('blueboxpublic') });
  }, []);

  React.useEffect(() => {
    const parsedProducts = Object.entries(productsList).map(([cardNumber, details]) => ({
      id: cardNumber,
      description: details?.product?.description,
      lineOfBusiness: details?.product?.line_of_business_type,
      paymentType: details?.product?.payment_type,
      locale: details?.profile?.locale_preference,
      type: details?.account?.relationship,
      setupDate: details?.status?.account_setup_date,
      status: details?.status?.account_status,
    }));
    if (parsedProducts.length === 0) {
      return;
    }
    updateDDL({ name: 'products', value: parsedProducts });
  }, [productsList]);

  return null;
};

export default memo(DigitalDataLayer);
